/* eslint-disable max-len */
import React from 'react';

const BlockQuoteIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M9 5v5.5C9 12.981 6.981 15 4.5 15H4v-1h.5C6.43 14 8 12.43 8 10.5V10H4V5h5zm7 0v5.5c0 2.481-2.019 4.5-4.5 4.5H11v-1h.5c1.93 0 3.5-1.57 3.5-3.5V10h-4V5h5z"
            transform="translate(-316.000000, -82.000000) translate(312.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default BlockQuoteIcon;
